import React from 'react';
import "../Styles/Twitte.css"

const Twitte = () => {
    return (
        <div className='twitte'>
            <div className='twitte-headline'>
                <h1>We Are Here To Make Your Dreams Come True</h1>
            </div>
            <div className='twitte-text'>
                <p>
                    WebBee is capable of offering  digital and creative support to organizations. A team of dedicated Youth geared resources with Hardworking, Insights Skill and Expertise.
                </p>
            </div>
        </div>
    );
};

export default Twitte;